import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { OAuthService } from 'angular-oauth2-oidc'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { map } from 'rxjs/operators'
import { User } from '../../shared/models/user'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  connectedUser: User = null

  constructor(private router: Router, private http: HttpClient, private oAuthService: OAuthService) {}

  getConnectedUser(): Observable<User> {
    return this.http
      .get<User>(`${environment.baseUrl}/utilisateurs/connected-user`)
      .pipe(map((connectedUser) => new User(connectedUser)))
  }

  logOut() {
    this.oAuthService.logOut({
      client_id: this.oAuthService.clientId,
      redirect_uri: this.oAuthService.redirectUri,
      response_type: 'code',
    })
  }
}
